// import Bell from './../json/mirrors/Bell.json';
// import Box from './../json/mirrors/Box.json';
// import Capsule from './../json/mirrors/Capsule.json';
// import Line from './../json/mirrors/Line.json';
// import Pulse from './../json/mirrors/Pulse.json';
// import Simple from './../json/mirrors/Simple.json';

import {apiConstructor} from '../api/ConstructorApi';

//img



let mirrors = [];


function initMirrors() {
    return new Promise((resolve, reject) => {
        apiConstructor.getMirrors()
        .then(res => {
            mirrors = res.data;
            resolve(res.data)
        })
        .catch(res => {
            reject(false)
        })
    })
}


export {mirrors, initMirrors}